module.exports = __webpack_public_path__ + "static/media/vasko@3x.ec47901e.png";